import { TipoGrupoParticipanteAtividadeColetivaEnum } from 'graphql/types.generated'
import { MetaRoot } from 'util/metaPath'

import { AtividadeColetivaGruposFormModel } from './model-atividadeColetivaGrupos'

export const createAtividadeColetivaGruposCalculations = (path: MetaRoot<AtividadeColetivaGruposFormModel>) => [
  {
    field: path.tipoGrupo.absolutePath(),
    updates: {
      [path.cidadaosParticipantes.absolutePath()]: (_, allValues: AtividadeColetivaGruposFormModel) =>
        allValues.tipoGrupo === TipoGrupoParticipanteAtividadeColetivaEnum.REUNIAO
          ? []
          : allValues.cidadaosParticipantes,
    },
  },
]
